import React, { useRef, useEffect, useCallback } from 'react';
import { number, bool, string, func } from 'prop-types';
import { translate } from 'react-i18next';

import { Button } from '@snapask/common-components';

import Latex from '@blueberry/components/Latex/Latex';

import styles from './ExplanationBlock.scss';
const cx = require('classnames/bind').bind(styles);

import whiteTheme from './whiteButtonTheme.scss';

const BREAK_WIDTH = 1025;

function ExplanationBlock({
  answer,
  correctAns,
  hasLatex,
  explanation,
  explanationImage,
  isLatestQuiz,
  clickNext,
  t,
  afterRender,
}) {
  const rootElement = useRef(null);
  useEffect(() => {
    if (hasLatex) {
      return;
    }

    onRender();
  }, [hasLatex, onRender, explanation]);

  const onRender = useCallback(() => {
    if (window.screen.width <= BREAK_WIDTH) {
      rootElement.current.scrollIntoView();

      return;
    }

    afterRender(rootElement.current.offsetHeight);
  }, [afterRender]);

  return (
    <div
      className={cx(styles.root, {
        correct: answer === correctAns,
        incorrect: answer > -1 && answer !== correctAns,
      })}
      ref={rootElement}
    >
      <h4>
        {t(
          `quizzes.explanation.${
            answer === correctAns ? 'correct' : 'incorrect'
          }`
        )}
      </h4>
      {hasLatex ? (
        <Latex content={explanation} onRender={onRender} />
      ) : (
        <p>{explanation}</p>
      )}
      {explanationImage && <img src={explanationImage} />}
      {isLatestQuiz ? (
        <div className={styles.finished}>{t('quizzes.finished')}</div>
      ) : (
        <Button
          text={t('quizzes.nextCTA')}
          onClick={clickNext}
          secondary
          theme={whiteTheme}
        />
      )}
    </div>
  );
}

ExplanationBlock.propTypes = {
  afterRender: func.isRequired,
  answer: number.isRequired,
  clickNext: func.isRequired,
  correctAns: number.isRequired,
  hasLatex: bool.isRequired,
  isLatestQuiz: bool.isRequired,
  t: func.isRequired,
  explanation: string,
  explanationImage: string,
};

ExplanationBlock.defaultProps = {
  explanation: '',
  explanationImage: '',
};

export default translate(['quizzes'])(ExplanationBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/AnswerBlock/components/ExplanationBlock/ExplanationBlock.jsx